import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("email", {
    createLetterTemplate: "Create a letter template",
    noTemplatesFound: "No templates found",
    posterNotFound: "No poster found",
    maximumFileSizeExceeded: "Maximum file size exceeded",
    maximumFileResolutionExceeded: "Maximum file resolution exceeded",
    templateName: "TemplateName",
    templateDescription: "Template Description",
    subjectLine: "Email subject",
    poster: "Poster",
    templatePosterTooltip: `Default is pulled from the general settings.
    Image .jpg or .png. The resolution should not
    exceed 1920x1080 px, file size no larger than 1 mb`,
    edit: "Edit",
    delete: "Delete",
    upload: "Upload",
    blocks: "Blocks",
    blockListIsEmpty: "The list of blocks is empty",
    selectBlock: "Select Block",
    save: "Save",
    watch: "Watch",
    close: "Close",
    back: "Back",
    broadcast: "Broadcast",
    senderAddress: "Sender address",
    globalEmailTooltip: `Will be used for all emails in
    within the framework of this event`,
    senderName: "Sender's name",
    settingsPosterTooltip: `Will be used for all emails in
    within the framework of this event. At
    can be changed as needed. For this
    go to the templates section and download
    required image .jpg or .png.
    Resolution should not exceed 1920x1080
    px, file size no more than 1 MB`,
    open: "Open",
    font: "Font",
    platformLink: "Link to platform in email",
    containsToken: "Contains a token",
    yes: "Yes",
    no: "No",
    hasntTokenTooltip: `If <b>"NO"</b> is selected, the link to the platform will have a generic address and the user of the platform,
    when clicking on it, will have to enter their email address and a one-time code to access it.`,
    hasTokenTooltip: `The link contains a token.
    When clicking on such a link, the user's information will be automatically extracted from his registration data,
    and he will not have to enter a one-time code when logging into the platform.
    To change this setting, go to your event settings.`,
    colorScheme: "Color Scheme",
    darkTheme: "Dark",
    lightTheme: "Light",
    accentTheme: "Accent",
    accentColor: "Accent color",
    darkColor: "Dark color",
    lightColor: "Light color",
    socialNetworks: "Social Networks",
    footerTemplateTooltip: `Will be displayed in the footer of the email.
    Add a link and the button will appear in letter`,
    vk: "VKontakte",
    classmates: "Odnoklassiniki",
    telegram: "Telegram",
    dzen: "Dzen",
    selectAtLeastOneBlock: "Select at least one block",
    setTemplateName: "Specify the name of the template",
    setMailSubject: "Specify the subject of the letter",
    availableValues: "Available values",
    removeTemplate: "Delete template",
    disclaimerTitle: "Disclaimer",
    disclaimerTooltip: `This is a system message
    appears in the email next to the button
    transition to the platform for an online or offline participant`,
    smtpServerSettings: "SMTP server settings",

    // Event calendar settings
    eventCalendarSaveError: "Error saving calendar settings",
    eventCalendarOnlineTitle:
        "Information for adding a participant to the online calendar",
    eventCalendarOfflineTitle:
        "Information for adding an offline participant to the calendar",
    eventCalendarOnlineInfoModalLabel:
        "Information for adding a participant to the online calendar",
    eventCalendarOfflineInfoModalLabel:
        "Information for adding an offline participant to the calendar",
    eventCalendarOnlineAddLinkModalLabel:
        "Add a link to the online platform in the description of the event in the calendar",
    eventCalendarOfflineAddLinkModalLabel:
        "Add a link to the offline platform in the description of the event in the calendar",
    eventCalendarEventNameModalLabel: "Name of the calendar event",
    eventCalendarEventDescrModalLabel:
        "Description of the event in the calendar",
    eventCalendarEventAddAddressModalLabel: "Add event address to calendar",
    eventCalendarEventAddressModalLabel: "Event address",
});
